<template>
  <div class="content">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex">
        <system-linked-combo v-model="sap" hide-stack></system-linked-combo>
      </div>
    </v-card>
    <!-- eslint-disable-next-line prettier/prettier -->
    <v-data-table
      :headers="headers" :items="metas" item-key="name" :loading="loading" class="elevation-1 content"
      dense fixed-header disable-pagination hide-default-footer
    >
      <template v-slot:top>
        <MetaDataList :dscList="descriptions" :systemId="sap.system" ref="metaListComp" @openform="formOpenFromList" />
        <MetaForm :dscList="descriptions" :systemId="sap.system" ref="metaFormComp" @openList="listOpenFromForm" />
      </template>
      <template v-slot:item.dataCount="{ item }"> {{ item.dataCount | comma }} </template>
      <template v-slot:item.actions="{ item }">
        <v-btn x-small max-height="20" @click="openListComp(item)">
          <v-icon small left color="primary">mdi-dots-horizontal-circle-outline</v-icon>
          <span v-html="$t('meta.descriptions')" />
        </v-btn>
        <!-- META_SAP_BATCH 의 경우 최초에 한번만 수집이 가능하다. -->
        <v-btn v-show="!(item.metaSap.tableName == 'META_SAP_BATCH' && item.dataCount > 0)" x-small max-height="20" @click="openFormComp(item)">
          <v-icon small left color="primary">mdi-plus-circle-outline</v-icon>
          <span v-html="$t('meta.collection')" />
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MetaDataList from './MetaDataList';
import MetaForm from './MetaForm';
import { comma } from '@/utils/formatter';

export default {
  name: 'Meta',
  components: {
    MetaDataList,
    MetaForm,
  },
  data() {
    return {
      loading: true,
      showForm: false,
      descriptions: {},
      metas: [],
      sap: { stack: 'ABAP', system: '' },
    };
  },
  computed: {
    ...mapState('preference/meta', ['metaSaps']),
    headers() {
      return [
        { text: this.$t('meta.metaData'), value: 'name', width: '50%', sortable: false },
        { text: this.$t('meta.count'), value: 'dataCount', sortable: false, align: 'end' },
        { text: '', value: 'actions', sortable: false },
      ];
    },
  },
  watch: {
    stackTypeList() {},
    metaSaps(value) {
      this.metas = value;
    },
    metas() {
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    sap: {
      deep: true,
      handler() {
        this.fetchMetas();
      },
    },
  },
  filters: {
    comma(v) {
      return comma(v ? v : 0);
    },
  },
  methods: {
    fetchMetas() {
      this.loading = true;
      this.$store.dispatch('preference/meta/getMetaSaps', { systemId: this.sap.system });
    },
    openListComp(item) {
      this.descriptions = item;
      this.$refs.metaListComp.$data.isShowList = true;
    },
    openFormComp(item) {
      this.descriptions = item;
      this.$refs.metaFormComp.$data.isShowForm = true;
    },
    listOpenFromForm() {
      // emit and open list
      const childElShow = this.$refs.metaListComp.$data.isShowList;
      if (!childElShow) this.$refs.metaListComp.$data.isShowList = true;
    },
    formOpenFromList(item) {
      this.openFormComp(item);
    },
    formatComma(v) {
      return comma(v);
    },
  },
};
</script>
